module.exports = __webpack_public_path__ + "img/logoLinkedin.caf5e01f.svg";